<main class="px-3">
    <img class="mw-100" src="/public/img/TIM ENTERPRISE_Orizz.svg" alt="Noovle a Tim enterprise brand" />
    <h1 class="mt-3 mb-5">Preventivatore</h1>

    @if (errorLoggin) {
    <div class="c-alert mt-4 fw-bold" role="alert">Invalid Credentials!</div>
    }

    @if (!production) {
    <form [formGroup]="singInForm" (ngSubmit)="signInWithEmailAndPassword()" class="mt-4 text-start">
        <div class="mb-3">
            <label for="userName" class="form-label fw-bold">Email</label>
            <input type="email" id="userName" class="form-control" formControlName="userName"
                placeholder="Inserisci la tua email">
        </div>
        <div class="mb-3">
            <label for="userPassword" class="form-label fw-bold">Password</label>
            <input type="password" id="userPassword" class="form-control" formControlName="userPassword"
                placeholder="Inserisci la tua password">
        </div>
        <button type="submit" class="btn btn-primary w-100 mt-3 py-2 fw-bold" [disabled]="singInForm.invalid">
            Accedi
        </button>
    </form>

    <div class="text-center mt-4 mb-2 text-muted">oppure</div>
    }
    <a href="javascript:void(0)" class="d-flex login-btn mt-2 justify-content-center" (click)="signInWithMicrosoft()">
        Sign-in with Microsoft
    </a>
</main>

<img class="logo" src="/public/img/logo.svg" alt="logo" />